<template>
  <base-dialog-form ref="uploadUsersDialog" :title="$t('import_users_csv')" color="secondary"
    icon="mdi-account-arrow-up">
    <v-row>
      <v-col>
        <v-select v-model="encoding" :items="encodingList" label="Encoding" required color="primary"
          persistent-hint></v-select>
      </v-col>
      <v-col>
        <v-file-input dense v-model="files" @change="onFileChange" color="primary" :label="$t('import_users_csv')"
          :show-size="true" prepend-icon="mdi-file-delimited-outline" outlined accept="text/csv" /></v-col>
      <v-col>
        <v-btn class="mx-2" @click="users = []" :disabled="!users || users.length === 0" color="warning">
          <v-icon class="mr-2">mdi-backspace-outline</v-icon>{{ $t("clear") }}</v-btn>
        <v-btn class="mx-2" @click="loadData(true)" :disabled="!users || users.length === 0 || selected.length === 0"
          color="primary">
          <v-icon class="mr-2">mdi-account-plus</v-icon>{{ $t("import_users_in_portal") }}</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="users">
        <DataTables :key="'upload-users-table-' + (bypassErrors ? 'bypass-on' : 'bypass-off')" :showSelect="true"
          :headers="headers" v-model="selected" :tableData="filteredUsers" itemKey="id" :height="400">
          <template v-slot:filter v-if="users.length > 0">
            <div class="d-flex flex-row flex-wrap align-center">
              <v-select dense v-model="statusFilter" :items="distinctStatus" append-icon="mdi-filter-variant"
                :label="$t('status')" clearable hide-details style="max-width: 300px" class="mr-4"></v-select>
              <v-select dense v-model="errorFilter" :items="distinctErrors" append-icon="mdi-alert-circle-outline"
                :label="$t('error')" clearable hide-details style="max-width: 300px" class="mr-4"></v-select>
              <v-switch dense v-model="bypassErrors" :label="$t('bypass_errors')" hide-details class="mr-4 mt-0 pt-0"></v-switch>
            </div>
          </template>
        </DataTables>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="users && users.length > 0"> </v-col>
    </v-row>
  </base-dialog-form>
</template>

<script>
import DataTables from "@/components/base/DataTables.vue";

export default {
  name: "upload-users",
  components: { DataTables },
  props: {},
  data() {
    return {
      files: null,
      users: null,
      selected: [],
      csv: null,
      errorFilter: "",
      statusFilter: "",
      bypassErrors: false,
      encoding: this.isWindowsPlatform() ? "windows-1252" : "utf-8",
      encodingList: [
        { value: "utf-8", text: "UTF-8" },
        { value: "windows-1252", text: "Windows (Western Latin)" },
      ],
      headers: [
        { text: "", value: "status", type: "icons" },
        { text: this.$t("error"), value: "msgTxt", type: "iconText" },
        { text: this.$t("portal"), value: "portal" },
        { text: this.$t("surname"), value: "surname" },
        { text: this.$t("name"), value: "name" },
        { text: this.$t("sex"), value: "sex" },
        { text: this.$t("fiscal_code"), value: "cFiscale" },
        { text: this.$t("email"), value: "email" },
        { text: this.$t("birth_date"), value: "birthDate", type: "date" },
        { text: this.$t("birth_city"), value: "birthCity", type: "text" },
        { text: this.$t("residence_address"), value: "resCity" },
        { text: this.$t("telephone"), value: "telephone" },
      ],
    };
  },
  computed: {
    distinctErrors() {
      let _ = this;
      if (!_.users) return [];
      return [...new Set(_.users.filter((user) => user.msgTxt && user.msgTxt.text).map((user) => user.msgTxt.text))];
    },
    distinctStatus() {
      let _ = this;
      if (!_.users) return [];
      return [...new Set(_.users.filter((user) => user.statusLabel).map((user) => user.statusLabel))];
    },
    filteredUsers() {
      let _ = this;
      if (!_.users) return [];
      return _.users
        .filter((user) => !_.errorFilter || (user.msgTxt && user.msgTxt.text === _.errorFilter))
        .filter((user) => !_.statusFilter || user.statusLabel === _.statusFilter);
    },
  },
  methods: {
    updateRowDisabledState() {
      let _ = this;
      if (!_.users) return;
      _.users = _.users.map((user) => {
        return {
          ...user,
          disabled: user.giaPresente || (!_.bypassErrors && !user.valido),
        };
      });
      _.selected = _.selected.filter((id) => {
        let row = _.users.find((user) => user.id === id);
        return row && !row.disabled;
      });
    },
    isWindowsPlatform() {
      if (typeof window === "undefined" || !window.navigator) return false;
      let platform =
        (window.navigator.userAgentData && window.navigator.userAgentData.platform) ||
        window.navigator.platform ||
        window.navigator.userAgent ||
        "";
      return /win/i.test(platform);
    },
    loadData(toImport = false) {
      let _ = this;
      //let b64csv = btoa(_.csv)
      let params = {
        csv: _.csv,
      };
      if (toImport) params.toImport = _.selected;
      params.bypassErrors = _.bypassErrors;
      _.selected = [5];
      _.chiamataAxios("PUT", "/auth/portal/csv/importFileUtenti", {
        body: params,
        dialogLoader: true,
        secTimeout: 500,
      }).then((response) => {
        if (response.msg.esito) {
          _.users = response.data.map((user) => {
            user.disabled = user.giaPresente || (!_.bypassErrors && !user.valido);
            user.msgTxt = {
              text: user.msgTxt,
              color: user.valido ? "success" : "error",
              icon: user.valido ? null : "mdi-close-circle",
            }; 
            if (user.importato) {
              user.status = [{ icon: "mdi-check-circle", color: "success" }];
              user.statusLabel = "Importato";
            } else if (user.giaPresente) {
              user.status = [{ icon: "mdi-check-circle", color: "success" }];
              user.statusLabel = "Già presente";
            } else {
              user.status = [
                { icon: "mdi-arrow-up-bold-circle", color: "success" },
              ];
              user.statusLabel = "Da importare";
            }
            return user;
          });
          if (toImport) _.$emit("isUpdated", true);
          _.files = null;
          _.selected = [];
        }
      });
    },
    open() {
      this.users = [];
      this.$refs.uploadUsersDialog.open();
    },
    onFileChange(e) {
      let _ = this;
      if (!_.files) return;
      if (_.files) {
        _.createCsv(_.files);
      }
    },
    createCsv(file) {
      let _ = this;
      _.csv = null;
      let reader = new FileReader();
      reader.onload = (e) => {
        _.csv = e.target.result;
        _.loadData();
        _.files = null;
      };
      if (file) reader.readAsText(file, _.encoding);
    },
  },
  mounted() {
    this.users = [];
  },
  watch: {
    bypassErrors() {
      this.updateRowDisabledState();
    },
  },
};
</script>
<style lang="scss"></style>
